import angular from 'angular';

module.exports = angular.module('admin.filters.noop', [
])
.filter('noop', function() {
  return (value) => value;
})
.name;




/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/noop.js
 **/